import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  ExistsAggregateBusinessAndBaseBusinessAllOfResult,
  ExistsAggregateBusinessAndBaseBusinessParameters,
} from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 関連取引が存在するかを確認する
 */
export class CheckDuplicateBaseBusinessUseCase {
  private repository: IAggregateBusinessRepository;
  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 関連取引の重複を確認する
   * @param business - 取引情報
   * @param limit - 取得する最大数
   */
  public async execute(
    business: IBusiness,
    limit = 100
  ): Promise<INetworkResult<ExistsAggregateBusinessAndBaseBusinessAllOfResult, Error>> {
    try {
      if (!business.salesDestinationNumber || !business.customerNumber) {
        // 基本的にフォームでバリデーションしているので返らない想定
        throw new Error('取引情報が不足しています');
      }
      const parameters: ExistsAggregateBusinessAndBaseBusinessParameters = {
        warehouseNumber: business.warehouseNumber,
        supplierNumber: business.supplierNumber,
        businessNumber: business.businessNumber,
        package: Number(business.package),
        customerNumber: business.customerNumber,
        salesDestinationNumber: business.salesDestinationNumber,
      };
      const result = await this.repository.checkDuplicateAggregateBusinessAndBusiness(parameters, limit);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
